import Vue from "vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import App from "./App.vue"
import PlatformAvatar from "./components/PlatformAvatar.vue"
import I18n from "./i18n"
import { NoticePlugin } from "./utils/notice"
import { updateSeo } from "./utils/seo"
import { installPwaGestureGuards } from "./utils/pwaGestureGuards"
import { installAppViewport } from "./utils/appViewport"
import "./assets/main.css"

Vue.use(ElementUI)
Vue.use(I18n)
Vue.use(NoticePlugin)
Vue.component("PlatformAvatar", PlatformAvatar)
Vue.config.productionTip = false
updateSeo("home")
installPwaGestureGuards()
installAppViewport()

new Vue({
  render: h => h(App)
}).$mount("#app")

Vue.nextTick(() => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      const bootSplash = document.getElementById("app-boot-splash")
      if (!bootSplash) return
      bootSplash.classList.add("handoff")
      window.setTimeout(() => bootSplash.remove(), 280)
    })
  })
})
